import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './akbets.features';
import { themeColors } from './akbets.config';
import { AKBetsLogotype } from './akbets.logotype';
import { AKBetsLogo } from 'src/layouts/LoginPage/logos/AKBetsLogo';
import AKBetsLoginImage from 'src/layouts/LoginPage/loginBgImages/AKBetsLoginImage.jpg';
import { AKBetsBrandIconWrapper, CompliancePopupLogo } from './akbets.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'AK Bets Backoffice',
    urls: {
        website: 'https://akbets.bet/',
        backoffice: 'https://backoffice.akbets.bet/',
    },
    BrandIcon: () => <AKBetsBrandIconWrapper />,
    Logotype: () => <AKBetsLogotype />,
    LogotypeLoginPage: () => <AKBetsLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={AKBetsLoginImage} />,
};
